import LayoutController from './layout.controller';

export default {
    template: require('./layout.tpl.html'),
    controller: LayoutController
};
